import { memo } from 'react';

/**
 * About — centered "About Me" section with the agent's bio paragraphs.
 * Collapses when there is no bio.
 */
export const About = memo(({ paragraphs = [] }) => {
  if (!paragraphs.length) return null;

  return (
    <section className="cw-section section-about" id="about">
      <div className="cw-container">
        <header className="section-head reveal">
          <p className="section-eyebrow">About Me</p>
          <h2 className="section-title">Your Trusted Insurance Partner</h2>
          <span className="section-bar" aria-hidden="true" />
        </header>
        <div className="about-body reveal">
          {paragraphs.map((para, i) => (
            <p key={i}>{para}</p>
          ))}
        </div>
      </div>
    </section>
  );
});
